const en = {
    "companyName": "Serenefire",
    "companySlogan": "Enhance humans. Improve the world.",
    "productLineName": "Serenefire Ares",
    "productLineSlogan": "Good Luck. Have Fun.",
    "productName": "Ares Guard",
    "productSlogan": "Create a healthy gaming environment together!",
    "yes": "Yes",
    "no": "No",
    "action": {
        "back": "Back",
        "view": "View",
        "edit": "Edit",
        "add": "Add",
        "update": "Update",
        "delete": "Delete",
        "confirmDeletion": "Confirm deletion?",
        "cancel": "Cancel",
        "verify": "Verify",
        "refreshGameData": "Refresh Game Data",
        "scan": "Scan",
        "startScanning": "Start Scanning",
        "identify": "Identify"
    },
    "hint": {
        "feature0": "Manage your game characters in one place!",
        "feature1": "Identify a game character quickly!"
    },
    "auth": {
        "email": "Email",
        "emailInvalid": "Email format is invalid",
        "password": "Password",
        "passwordInvalid": "Password must be at least 6 characters",
        "passwordRequired": "Password is required",
        "confirmPassword": "Confirm password",
        "passwordsNotMatch": "Passwords do not match",
        "displayName": "Display name",
        "displayNameInvalid": "Display name must be between 1 to 20 characters",
        "signUp": "Sign up",
        "signIn": "Sign in",
        "signOut": "Sign out",
        "authenticating": "Authenticating...",
        "signedInHint": "You are signed in.",
        "signedOutHint": "You are signed out."
    },
    "starcraft2": {
        "region": {
            "us": "Americas",
            "eu": "Europe",
            "kr": "Asia",
            "cn": "China",
            "unknown": "Unknown"
        },
        "realm": {
            "us": "US",
            "latAm": "LatAm",
            "europe": "Europe",
            "russia": "Russia",
            "korea": "Korea",
            "taiwan": "Taiwan",
            "china": "China",
            "unknown": "Unknown"
        }
    },
    "navbar": {
        "userError": "User error",
        "initializing": "Initializing...",
        "initializeFailed": "Failed to initialize"
    },
    "articlesPage": {
        "pageTitle": "Articles"
    },
    "articlePage": {
        "pageTitle": "Article"
    },
    "indexPage": {
        "hintWelcome": "Welcome to Ares Guard",
        "hintSignIn": "Already have a Serenefire account? Sign in to continue.",
        "hintSignUp": "Don't have a Serenefire account? Sign up for one.",
        "characters": "Characters"
    },
    "ocrPage": {
        "pageTitle": "Scanning",
        "imageForOcr": "Image for OCR",
        "launchCameraApp": "Launch Camera App",
        "pickImageFile": "Pick Image File",
        "targetTextHint": "Please make sure the {targetTextName} is big and clear enough!",
        "characterName": "character name"
    },
    "charactersPage": {
        "pageTitle": "Characters",
        "addCharacter": "Add Character",
        "noCharacter": "There is no character.",
        "loadMore": "Load More",
        "loading": "Loading..."
    },
    "characterViewPart": {
        "game": "Game",
        "identificationName": "Identification Name",
        "verificationNumber": "Verification Number",
        "isVerified": "Is Verified",
        "gameDataRefreshedAt": "Game Data Refreshed at",
        "createdAt": "Created at",
        "updatedAt": "Updated at"
    },
    "sc2CharacterView": {
        "avatar": "Avatar",
        "profileUrl": "Profile URL",
        "name": "Name",
        "changeNameToIdentificationName": "You better change your verified character's name to the identification name in game.",
        "nameNotSameAsIdentificationName": "The name is not same as the identification name.",
        "region": "Region",
        "realm": "Realm"
    },
    "characterView": {
        "characterInvalid": "Character is invalid."
    },
    "characterPage": {},
    "editSc2CharacterView": {
        "identificationName": "Identification Name",
        "identificationNameInvalid": "Only accept English letters and numbers. Start with a letter. Be 3-12 characters long.",
        "profileUrl": "Profile URL",
        "profileUrlUnchangeableLater": "Profile URL cannot be changed later.",
        "profileUrlUnchangeable": "Profile URL cannot be changed.",
        "profileUrlInvalid": "Profile URL is invalid."
    },
    "editCharacterView": {
        "characterInvalid": "Character is invalid."
    },
    "editCharacterPage": {
        "pageTitle": "Edit Character",
        "game": "Game"
    },
    "refreshSc2CharacterGameDataView": {
        "profileUrl": "Profile URL"
    },
    "refreshCharacterGameDataView": {
        "characterInvalid": "Character is invalid."
    },
    "refreshCharacterGameDataPage": {
        "pageTitle": "Refresh Character Game Data",
        "game": "Game",
        "identificationName": "Identification Name",
        "verificationNumber": "Verification Number",
        "verifyCharacter": "Before refreshing game data, verify your character."
    },
    "verifySc2CharacterView": {
        "profileUrl": "Profile URL"
    },
    "verifyCharacterView": {
        "characterInvalid": "Character is invalid."
    },
    "verifyCharacterPage": {
        "pageTitle": "Verify Character",
        "game": "Game",
        "identificationName": "Identification Name",
        "verificationNumber": "Verification Number",
        "changeNameToVerificationNumber": "Before verifying, change your character's name to the verification number in game."
    },
    "identifySc2CharacterView": {
        "clanTag": "Clan Tag",
        "identificationNameOrVerificationNumber": "Identification Name or Verification Number",
        "identificationNameOrVerificationNumberInvalid": "Identification Name or Verification Number is required.",
        "scanOrTypeInTargetCharacterName": "You can scan or type in the target character's name.",
        "typeInTargetCharacterName": "You can type in the target character's name."
    },
    "identifyCharacterView": {
        "gameInvalid": "Game is invalid."
    },
    "identifyCharacterPage": {
        "pageTitle": "Identify Character",
        "game": "Game",
        "noIdentifiedCharacter": "There is no identified character."
    }
};

export const l10n = en;
